import Button from '@mui/material/Button';

import { RouterLink } from 'src/routes/components';

import { useTranslate } from 'src/locales';

import { useRedirectToSignIn } from '../hooks';

// ----------------------------------------------------------------------

export function SignInButton({ sx, ...other }) {
  const { t } = useTranslate();

  const urlToSignIn = useRedirectToSignIn();

  return (
    <Button
      fullWidth
      size="large"
      href={urlToSignIn}
      variant="contained"
      component={RouterLink}
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      {t('Sign in')}
    </Button>
  );
}
